import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { AutenticacionService } from '../../shared/services/autenticacion.service';

import { Constantes } from '../../shared/constantes';
import { Mensaje } from '../../shared/models/mensaje';

@Injectable()
export class RequestInterceptor implements HttpInterceptor {

  constructor(private autenticacionService: AutenticacionService, private router: Router) { }

  intercept(httpRequest: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(httpRequest).do((event: HttpEvent<any>) => {
      if (event instanceof HttpResponse) {
        // do stuff with response if you want
      }
    }, (error: any) => {
      if (error instanceof HttpErrorResponse) {
        if (error.status === 401) {
          if (error.error.object == Constantes.CONSULTA) {
            this.router.navigate(['/consulta']);
            this.autenticacionService.setMensaje(error.error.mensaje ? error.error.mensaje : 'Sesion no válida');
          } else if (error.error.object == Constantes.CONSULTA_INTERNA) {
            this.router.navigate(['/consulta-runt']);
            this.autenticacionService.setMensaje(error.error.mensaje ? error.error.mensaje : 'Ip no válida');
          }
        }
      }
    });
  }

}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/QA/HistoricoConductor/frontend/src/app/core/interceptors/request.interceptor.ts